import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=0f5e1468"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=0f5e1468&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5e1468')) {
      api.createRecord('0f5e1468', component.options)
    } else {
      api.reload('0f5e1468', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=0f5e1468", function () {
      api.rerender('0f5e1468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/task/Form.vue"
export default component.exports